import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0c93ff14 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _4c03b49e = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _f28e2d5e = () => interopDefault(import('../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _0d6921d8 = () => interopDefault(import('../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _0e1a7f32 = () => interopDefault(import('../pages/account/addresses/index.vue' /* webpackChunkName: "pages/account/addresses/index" */))
const _781ede3b = () => interopDefault(import('../pages/account/edit/index.vue' /* webpackChunkName: "pages/account/edit/index" */))
const _7df4a054 = () => interopDefault(import('../pages/account/orders/index.vue' /* webpackChunkName: "pages/account/orders/index" */))
const _e2290e1a = () => interopDefault(import('../pages/account/wishlist.vue' /* webpackChunkName: "pages/account/wishlist" */))
const _4a2cf516 = () => interopDefault(import('../pages/account/addresses/new.vue' /* webpackChunkName: "pages/account/addresses/new" */))
const _26a38c05 = () => interopDefault(import('../pages/account/edit/email.vue' /* webpackChunkName: "pages/account/edit/email" */))
const _bda9e37c = () => interopDefault(import('../pages/account/edit/password.vue' /* webpackChunkName: "pages/account/edit/password" */))
const _c66ca084 = () => interopDefault(import('../pages/account/orders/_id.vue' /* webpackChunkName: "pages/account/orders/_id" */))
const _41f2913a = () => interopDefault(import('../pages/account/addresses/_id/edit.vue' /* webpackChunkName: "pages/account/addresses/_id/edit" */))
const _e3e063a8 = () => interopDefault(import('../pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _6925c352 = () => interopDefault(import('../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _8d4b54e0 = () => interopDefault(import('../pages/checkout/guest-shipping.vue' /* webpackChunkName: "pages/checkout/guest-shipping" */))
const _189b2feb = () => interopDefault(import('../pages/checkout/pay.vue' /* webpackChunkName: "pages/checkout/pay" */))
const _1e7c5b7b = () => interopDefault(import('../pages/checkout/shipping.vue' /* webpackChunkName: "pages/checkout/shipping" */))
const _3a848009 = () => interopDefault(import('../pages/compare.vue' /* webpackChunkName: "pages/compare" */))
const _558851c4 = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _5be46890 = () => interopDefault(import('../pages/dior-expertise.vue' /* webpackChunkName: "pages/dior-expertise" */))
const _3d7c1eac = () => interopDefault(import('../pages/error.vue' /* webpackChunkName: "pages/error" */))
const _781f36ae = () => interopDefault(import('../pages/faqs.vue' /* webpackChunkName: "pages/faqs" */))
const _5c981c3a = () => interopDefault(import('../pages/health-check.vue' /* webpackChunkName: "pages/health-check" */))
const _7944b8e6 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _4d919504 = () => interopDefault(import('../pages/new-in.vue' /* webpackChunkName: "pages/new-in" */))
const _79dae1a3 = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _a7a6a3a2 = () => interopDefault(import('../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _011227d3 = () => interopDefault(import('../pages/sale.vue' /* webpackChunkName: "pages/sale" */))
const _2e6e3098 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _49ac5462 = () => interopDefault(import('../pages/search/_name.vue' /* webpackChunkName: "pages/search/_name" */))
const _c27a6180 = () => interopDefault(import('../pages/spin-the-wheel.vue' /* webpackChunkName: "pages/spin-the-wheel" */))
const _7f1d5b00 = () => interopDefault(import('../pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _66a63e46 = () => interopDefault(import('../pages/unsubscribe-maillist.vue' /* webpackChunkName: "pages/unsubscribe-maillist" */))
const _4b97eeee = () => interopDefault(import('../pages/auth/recover.vue' /* webpackChunkName: "pages/auth/recover" */))
const _30816b2c = () => interopDefault(import('../pages/orders/error.vue' /* webpackChunkName: "pages/orders/error" */))
const _61fd7db1 = () => interopDefault(import('../pages/abandonedcart/subscriber/unsubscribe.vue' /* webpackChunkName: "pages/abandonedcart/subscriber/unsubscribe" */))
const _f06ab748 = () => interopDefault(import('../pages/guest-order/_id/success.vue' /* webpackChunkName: "pages/guest-order/_id/success" */))
const _61173916 = () => interopDefault(import('../pages/orders/_id/create-review.vue' /* webpackChunkName: "pages/orders/_id/create-review" */))
const _1e724a90 = () => interopDefault(import('../pages/orders/_id/success.vue' /* webpackChunkName: "pages/orders/_id/success" */))
const _23795cbd = () => interopDefault(import('../pages/_/create-review.vue' /* webpackChunkName: "pages/_/create-review" */))
const _3d50c7c6 = () => interopDefault(import('../pages/_/index.vue' /* webpackChunkName: "pages/_/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/furla/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/ar",
    component: _0c93ff14,
    name: "index___ar"
  }, {
    path: "/en",
    component: _0c93ff14,
    name: "index___en"
  }, {
    path: "/ar/about",
    component: _4c03b49e,
    name: "about___ar"
  }, {
    path: "/ar/account",
    component: _f28e2d5e,
    children: [{
      path: "",
      component: _0d6921d8,
      name: "account___ar"
    }, {
      path: "addresses",
      component: _0e1a7f32,
      name: "account-addresses___ar"
    }, {
      path: "edit",
      component: _781ede3b,
      name: "account-edit___ar"
    }, {
      path: "orders",
      component: _7df4a054,
      name: "account-orders___ar"
    }, {
      path: "wishlist",
      component: _e2290e1a,
      name: "account-wishlist___ar"
    }, {
      path: "addresses/new",
      component: _4a2cf516,
      name: "account-addresses-new___ar"
    }, {
      path: "edit/email",
      component: _26a38c05,
      name: "account-edit-email___ar"
    }, {
      path: "edit/password",
      component: _bda9e37c,
      name: "account-edit-password___ar"
    }, {
      path: "orders/:id",
      component: _c66ca084,
      name: "account-orders-id___ar"
    }, {
      path: "addresses/:id/edit",
      component: _41f2913a,
      name: "account-addresses-id-edit___ar"
    }]
  }, {
    path: "/ar/cart",
    component: _e3e063a8,
    name: "cart___ar"
  }, {
    path: "/ar/checkout",
    component: _6925c352,
    name: "checkout___ar",
    children: [{
      path: "guest-shipping",
      component: _8d4b54e0,
      name: "checkout-guest-shipping___ar"
    }, {
      path: "pay",
      component: _189b2feb,
      name: "checkout-pay___ar"
    }, {
      path: "shipping",
      component: _1e7c5b7b,
      name: "checkout-shipping___ar"
    }]
  }, {
    path: "/ar/compare",
    component: _3a848009,
    name: "compare___ar"
  }, {
    path: "/ar/contact",
    component: _558851c4,
    name: "contact___ar"
  }, {
    path: "/ar/dior-expertise",
    component: _5be46890,
    name: "dior-expertise___ar"
  }, {
    path: "/ar/error",
    component: _3d7c1eac,
    name: "error___ar"
  }, {
    path: "/ar/faqs",
    component: _781f36ae,
    name: "faqs___ar"
  }, {
    path: "/ar/health-check",
    component: _5c981c3a,
    name: "health-check___ar"
  }, {
    path: "/ar/login",
    component: _7944b8e6,
    name: "login___ar"
  }, {
    path: "/ar/new-in",
    component: _4d919504,
    name: "new-in___ar"
  }, {
    path: "/ar/privacy-policy",
    component: _79dae1a3,
    name: "privacy-policy___ar"
  }, {
    path: "/ar/register",
    component: _a7a6a3a2,
    name: "register___ar"
  }, {
    path: "/ar/sale",
    component: _011227d3,
    name: "sale___ar"
  }, {
    path: "/ar/search",
    component: _2e6e3098,
    name: "search___ar",
    children: [{
      path: ":name?",
      component: _49ac5462,
      name: "search-name___ar"
    }]
  }, {
    path: "/ar/spin-the-wheel",
    component: _c27a6180,
    name: "spin-the-wheel___ar"
  }, {
    path: "/ar/terms-and-conditions",
    component: _7f1d5b00,
    name: "terms-and-conditions___ar"
  }, {
    path: "/ar/unsubscribe-maillist",
    component: _66a63e46,
    name: "unsubscribe-maillist___ar"
  }, {
    path: "/en/about",
    component: _4c03b49e,
    name: "about___en"
  }, {
    path: "/en/account",
    component: _f28e2d5e,
    children: [{
      path: "",
      component: _0d6921d8,
      name: "account___en"
    }, {
      path: "addresses",
      component: _0e1a7f32,
      name: "account-addresses___en"
    }, {
      path: "edit",
      component: _781ede3b,
      name: "account-edit___en"
    }, {
      path: "orders",
      component: _7df4a054,
      name: "account-orders___en"
    }, {
      path: "wishlist",
      component: _e2290e1a,
      name: "account-wishlist___en"
    }, {
      path: "addresses/new",
      component: _4a2cf516,
      name: "account-addresses-new___en"
    }, {
      path: "edit/email",
      component: _26a38c05,
      name: "account-edit-email___en"
    }, {
      path: "edit/password",
      component: _bda9e37c,
      name: "account-edit-password___en"
    }, {
      path: "orders/:id",
      component: _c66ca084,
      name: "account-orders-id___en"
    }, {
      path: "addresses/:id/edit",
      component: _41f2913a,
      name: "account-addresses-id-edit___en"
    }]
  }, {
    path: "/en/cart",
    component: _e3e063a8,
    name: "cart___en"
  }, {
    path: "/en/checkout",
    component: _6925c352,
    name: "checkout___en",
    children: [{
      path: "guest-shipping",
      component: _8d4b54e0,
      name: "checkout-guest-shipping___en"
    }, {
      path: "pay",
      component: _189b2feb,
      name: "checkout-pay___en"
    }, {
      path: "shipping",
      component: _1e7c5b7b,
      name: "checkout-shipping___en"
    }]
  }, {
    path: "/en/compare",
    component: _3a848009,
    name: "compare___en"
  }, {
    path: "/en/contact",
    component: _558851c4,
    name: "contact___en"
  }, {
    path: "/en/dior-expertise",
    component: _5be46890,
    name: "dior-expertise___en"
  }, {
    path: "/en/error",
    component: _3d7c1eac,
    name: "error___en"
  }, {
    path: "/en/faqs",
    component: _781f36ae,
    name: "faqs___en"
  }, {
    path: "/en/health-check",
    component: _5c981c3a,
    name: "health-check___en"
  }, {
    path: "/en/login",
    component: _7944b8e6,
    name: "login___en"
  }, {
    path: "/en/new-in",
    component: _4d919504,
    name: "new-in___en"
  }, {
    path: "/en/privacy-policy",
    component: _79dae1a3,
    name: "privacy-policy___en"
  }, {
    path: "/en/register",
    component: _a7a6a3a2,
    name: "register___en"
  }, {
    path: "/en/sale",
    component: _011227d3,
    name: "sale___en"
  }, {
    path: "/en/search",
    component: _2e6e3098,
    name: "search___en",
    children: [{
      path: ":name?",
      component: _49ac5462,
      name: "search-name___en"
    }]
  }, {
    path: "/en/spin-the-wheel",
    component: _c27a6180,
    name: "spin-the-wheel___en"
  }, {
    path: "/en/terms-and-conditions",
    component: _7f1d5b00,
    name: "terms-and-conditions___en"
  }, {
    path: "/en/unsubscribe-maillist",
    component: _66a63e46,
    name: "unsubscribe-maillist___en"
  }, {
    path: "/ar/auth/recover",
    component: _4b97eeee,
    name: "auth-recover___ar"
  }, {
    path: "/ar/orders/error",
    component: _30816b2c,
    name: "orders-error___ar"
  }, {
    path: "/en/auth/recover",
    component: _4b97eeee,
    name: "auth-recover___en"
  }, {
    path: "/en/orders/error",
    component: _30816b2c,
    name: "orders-error___en"
  }, {
    path: "/ar/abandonedcart/subscriber/unsubscribe",
    component: _61fd7db1,
    name: "abandonedcart-subscriber-unsubscribe___ar"
  }, {
    path: "/en/abandonedcart/subscriber/unsubscribe",
    component: _61fd7db1,
    name: "abandonedcart-subscriber-unsubscribe___en"
  }, {
    path: "/ar/guest-order/:id?/success",
    component: _f06ab748,
    name: "guest-order-id-success___ar"
  }, {
    path: "/ar/orders/:id?/create-review",
    component: _61173916,
    name: "orders-id-create-review___ar"
  }, {
    path: "/ar/orders/:id?/success",
    component: _1e724a90,
    name: "orders-id-success___ar"
  }, {
    path: "/en/guest-order/:id?/success",
    component: _f06ab748,
    name: "guest-order-id-success___en"
  }, {
    path: "/en/orders/:id?/create-review",
    component: _61173916,
    name: "orders-id-create-review___en"
  }, {
    path: "/en/orders/:id?/success",
    component: _1e724a90,
    name: "orders-id-success___en"
  }, {
    path: "/ar/*/create-review",
    component: _23795cbd,
    name: "all-create-review___ar"
  }, {
    path: "/en/*/create-review",
    component: _23795cbd,
    name: "all-create-review___en"
  }, {
    path: "/en/*",
    component: _3d50c7c6,
    name: "all___en"
  }, {
    path: "/ar/*",
    component: _3d50c7c6,
    name: "all___ar"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
